import tokens from '../tokens/js/tokens';
// Definition of the "neutral" color scheme
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
export const NEUTRAL_LIGHT_HARD_DEFAULT = {
    background: tokens.colors.midnight[800].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[600].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Light + Hard + Hover
export const NEUTRAL_LIGHT_HARD_HOVER = {
    background: tokens.colors.midnight[600].value,
    border: tokens.colors.midnight[600].value,
    foregroundAlt: tokens.colors.midnight[400].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Light + Hard + Pressed
export const NEUTRAL_LIGHT_HARD_PRESSED = {
    background: tokens.colors.midnight[200].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[400].value,
    foreground: tokens.colors.midnight[400].value,
    active: tokens.colors.active[100].value
};
// Light + Hard + Focus
export const NEUTRAL_LIGHT_HARD_FOCUS = {
    background: tokens.colors.midnight[800].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[600].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Light + Hard + Disabled
export const NEUTRAL_LIGHT_HARD_DISABLED = {
    background: tokens.colors.midnight[300].value,
    border: tokens.colors.midnight[300].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Light + White + Default
export const NEUTRAL_LIGHT_WHITE_DEFAULT = {
    background: 'transparent',
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[300].value,
    foreground: tokens.colors.midnight[800].value,
    active: tokens.colors.active[100].value
};
// Light + White + Hover
export const NEUTRAL_LIGHT_WHITE_HOVER = {
    background: 'transparent',
    border: tokens.colors.midnight[400].value,
    foregroundAlt: tokens.colors.midnight[400].value,
    foreground: tokens.colors.midnight[800].value,
    active: tokens.colors.active[100].value
};
// Light + White + Pressed
export const NEUTRAL_LIGHT_WHITE_PRESSED = {
    background: 'transparent',
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Light + White + Focus
export const NEUTRAL_LIGHT_WHITE_FOCUS = {
    background: 'transparent',
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Light + White + Disabled
export const NEUTRAL_LIGHT_WHITE_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Ghost + Default
export const NEUTRAL_LIGHT_GHOST_DEFAULT = {
    background: 'transparent',
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Light + Ghost + Hover
export const NEUTRAL_LIGHT_GHOST_HOVER = {
    background: 'transparent',
    border: tokens.colors.midnight[400].value,
    foregroundAlt: tokens.colors.midnight[400].value,
    foreground: tokens.colors.midnight[400].value
};
// Light + Ghost + Pressd
export const NEUTRAL_LIGHT_GHOST_PRESSED = {
    background: 'transparent',
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Ghost + Focus
export const NEUTRAL_LIGHT_GHOST_FOCUS = {
    background: 'transparent',
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Light + Ghost + Disabled
export const NEUTRAL_LIGHT_GHOST_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Bare + Default
export const NEUTRAL_LIGHT_BARE_DEFAULT = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.midnight[300].value,
    foreground: tokens.colors.midnight[800].value
};
// Light + Bare + Hover
export const NEUTRAL_LIGHT_BARE_HOVER = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[150].value,
    foregroundAlt: tokens.colors.midnight[400].value,
    foreground: tokens.colors.midnight[800].value
};
// Light + Bare + Pressed
export const NEUTRAL_LIGHT_BARE_PRESSED = {
    background: tokens.colors.midnight[200].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[400].value,
    foreground: tokens.colors.midnight[400].value
};
// Light + Bare + Focus
export const NEUTRAL_LIGHT_BARE_FOCUS = {
    background: 'transparent',
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Light + Bare + Disabled
export const NEUTRAL_LIGHT_BARE_DISABLED = {
    background: 'transparent',
    border: 'transparent',
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
export const NEUTRAL_DARK_HARD_DEFAULT = {
    background: tokens.colors.midnight[200].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[400].value,
    foreground: tokens.colors.midnight[800].value,
    active: tokens.colors.active[100].value
};
// Dark + Hard + Hover
export const NEUTRAL_DARK_HARD_HOVER = {
    background: tokens.colors.midnight[400].value,
    border: tokens.colors.midnight[400].value,
    foregroundAlt: tokens.colors.midnight[600].value,
    foreground: tokens.colors.midnight[800].value,
    active: tokens.colors.active[100].value
};
// Dark + Hard + Pressed
export const NEUTRAL_DARK_HARD_PRESSED = {
    background: tokens.colors.midnight[800].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[600].value,
    foreground: tokens.colors.midnight[600].value,
    active: tokens.colors.active[100].value
};
// Dark + Hard + Focus
export const NEUTRAL_DARK_HARD_FOCUS = {
    background: tokens.colors.midnight[200].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[400].value,
    foreground: tokens.colors.midnight[800].value,
    active: tokens.colors.active[100].value
};
// Dark + Hard + Disabled
export const NEUTRAL_DARK_HARD_DISABLED = {
    background: tokens.colors.midnight[700].value,
    border: tokens.colors.midnight[700].value,
    foregroundAlt: tokens.colors.midnight[850].value,
    foreground: tokens.colors.midnight[850].value,
    active: tokens.colors.active[100].value
};
// Dark + White + Default
export const NEUTRAL_DARK_WHITE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[700].value,
    foregroundAlt: tokens.colors.midnight[700].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Dark + White + Hover
export const NEUTRAL_DARK_WHITE_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[500].value,
    foregroundAlt: tokens.colors.midnight[500].value,
    foreground: tokens.colors.midnight[800].value,
    active: tokens.colors.active[100].value
};
// Dark + White + Pressed
export const NEUTRAL_DARK_WHITE_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[700].value,
    foregroundAlt: tokens.colors.midnight[700].value,
    foreground: tokens.colors.midnight[700].value,
    active: tokens.colors.active[100].value
};
// Dark + White + Focus
export const NEUTRAL_DARK_WHITE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Dark + White + Disabled
export const NEUTRAL_DARK_WHITE_DISABLED = {
    background: tokens.colors.midnight[700].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[850].value,
    foreground: tokens.colors.midnight[850].value,
    active: tokens.colors.active[100].value
};
// Dark + Ghost + Default
export const NEUTRAL_DARK_GHOST_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Dark + Ghost + Hover
export const NEUTRAL_DARK_GHOST_HOVER = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[500].value,
    foregroundAlt: tokens.colors.midnight[500].value,
    foreground: tokens.colors.midnight[500].value,
    active: tokens.colors.active[100].value
};
// Dark + Ghost + Pressd
export const NEUTRAL_DARK_GHOST_PRESSED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[700].value,
    foregroundAlt: tokens.colors.midnight[700].value,
    foreground: tokens.colors.midnight[700].value,
    active: tokens.colors.active[100].value
};
// Dark + Ghost + Focus
export const NEUTRAL_DARK_GHOST_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Dark + Ghost + Disabled
export const NEUTRAL_DARK_GHOST_DISABLED = {
    background: tokens.colors.midnight[700].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[850].value,
    foreground: tokens.colors.midnight[850].value,
    active: tokens.colors.active[100].value
};
// Dark + Bare + Default
export const NEUTRAL_DARK_BARE_DEFAULT = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.midnight[700].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Dark + Bare + Hover
export const NEUTRAL_DARK_BARE_HOVER = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[850].value,
    foregroundAlt: tokens.colors.midnight[600].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Dark + Bare + Pressed
export const NEUTRAL_DARK_BARE_PRESSED = {
    background: tokens.colors.midnight[800].value,
    border: tokens.colors.midnight[800].value,
    foregroundAlt: tokens.colors.midnight[600].value,
    foreground: tokens.colors.midnight[600].value,
    active: tokens.colors.active[100].value
};
// Dark + Bare + Focus
export const NEUTRAL_DARK_BARE_FOCUS = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value,
    active: tokens.colors.active[100].value
};
// Dark + Bare + Disabled
export const NEUTRAL_DARK_BARE_DISABLED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value,
    active: tokens.colors.active[100].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
export const NEUTRAL_LIGHT_HARD = {
    default: NEUTRAL_LIGHT_HARD_DEFAULT,
    disabled: NEUTRAL_LIGHT_HARD_DISABLED,
    focus: NEUTRAL_LIGHT_HARD_FOCUS,
    hover: NEUTRAL_LIGHT_HARD_HOVER,
    pressed: NEUTRAL_LIGHT_HARD_PRESSED
};
// Light + White
export const NEUTRAL_LIGHT_WHITE = {
    default: NEUTRAL_LIGHT_WHITE_DEFAULT,
    disabled: NEUTRAL_LIGHT_WHITE_DISABLED,
    focus: NEUTRAL_LIGHT_WHITE_FOCUS,
    hover: NEUTRAL_LIGHT_WHITE_HOVER,
    pressed: NEUTRAL_LIGHT_WHITE_PRESSED
};
// Light + Ghost
export const NEUTRAL_LIGHT_GHOST = {
    default: NEUTRAL_LIGHT_GHOST_DEFAULT,
    disabled: NEUTRAL_LIGHT_GHOST_DISABLED,
    focus: NEUTRAL_LIGHT_GHOST_FOCUS,
    hover: NEUTRAL_LIGHT_GHOST_HOVER,
    pressed: NEUTRAL_LIGHT_GHOST_PRESSED
};
// Light + Bare
export const NEUTRAL_LIGHT_BARE = {
    default: NEUTRAL_LIGHT_BARE_DEFAULT,
    disabled: NEUTRAL_LIGHT_BARE_DISABLED,
    focus: NEUTRAL_LIGHT_BARE_FOCUS,
    hover: NEUTRAL_LIGHT_BARE_HOVER,
    pressed: NEUTRAL_LIGHT_BARE_PRESSED
};
// Dark + Hard
export const NEUTRAL_DARK_HARD = {
    default: NEUTRAL_DARK_HARD_DEFAULT,
    disabled: NEUTRAL_DARK_HARD_DISABLED,
    focus: NEUTRAL_DARK_HARD_FOCUS,
    hover: NEUTRAL_DARK_HARD_HOVER,
    pressed: NEUTRAL_DARK_HARD_PRESSED
};
// Dark + White
export const NEUTRAL_DARK_WHITE = {
    default: NEUTRAL_DARK_WHITE_DEFAULT,
    disabled: NEUTRAL_DARK_WHITE_DISABLED,
    focus: NEUTRAL_DARK_WHITE_FOCUS,
    hover: NEUTRAL_DARK_WHITE_HOVER,
    pressed: NEUTRAL_DARK_WHITE_PRESSED
};
// Dark + Ghost
export const NEUTRAL_DARK_GHOST = {
    default: NEUTRAL_DARK_GHOST_DEFAULT,
    disabled: NEUTRAL_DARK_GHOST_DISABLED,
    focus: NEUTRAL_DARK_GHOST_FOCUS,
    hover: NEUTRAL_DARK_GHOST_HOVER,
    pressed: NEUTRAL_DARK_GHOST_PRESSED
};
// Dark + Bare
export const NEUTRAL_DARK_BARE = {
    default: NEUTRAL_DARK_BARE_DEFAULT,
    disabled: NEUTRAL_DARK_BARE_DISABLED,
    focus: NEUTRAL_DARK_BARE_FOCUS,
    hover: NEUTRAL_DARK_BARE_HOVER,
    pressed: NEUTRAL_DARK_BARE_PRESSED
};
// Light
export const NEUTRAL_LIGHT = {
    bare: NEUTRAL_LIGHT_BARE,
    ghost: NEUTRAL_LIGHT_GHOST,
    hard: NEUTRAL_LIGHT_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: NEUTRAL_LIGHT_HARD,
    white: NEUTRAL_LIGHT_WHITE
};
// Dark
export const NEUTRAL_DARK = {
    bare: NEUTRAL_DARK_BARE,
    ghost: NEUTRAL_DARK_GHOST,
    hard: NEUTRAL_DARK_HARD,
    // This color scheme does not have "Soft" but for convenience we match it to "Hard".
    soft: NEUTRAL_DARK_HARD,
    white: NEUTRAL_DARK_WHITE
};
// Color schema
const NEUTRAL = {
    dark: NEUTRAL_DARK,
    light: NEUTRAL_LIGHT
};
export default NEUTRAL;
//# sourceMappingURL=palette.schema.neutral.js.map